exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about #services[data-v-0e8c4356]{margin:0 auto;max-width:70rem}", ""]);

// exports
